export const EXPLORER_IDS = ["lily", "juniper", "rowan"] as const;

export type ExplorerId = (typeof EXPLORER_IDS)[number];

export interface ExplorerDefinition {
  id: ExplorerId;
  name: string;
  title: string;
  description: string;
  portraitClass: string;
  modelPath: string;
  colors: {
    skin: number;
    hair: number;
    jacket: number;
    trousers: number;
    pack: number;
    packLight: number;
    scarf: number;
  };
}

export const explorers: readonly ExplorerDefinition[] = [
  {
    id: "lily",
    name: "Lily",
    title: "Violet Trail Explorer",
    description:
      "Golden twin buns, yellow trail clothes, and a violet field pack.",
    portraitClass: "explorer-portrait--lily",
    modelPath: "/assets/kenney-mini-characters/lily-female-b.glb",
    colors: {
      skin: 0xb96f45,
      hair: 0x402820,
      jacket: 0x35a7a0,
      trousers: 0x315e83,
      pack: 0x65449a,
      packLight: 0xa98bd2,
      scarf: 0xe95786,
    },
  },
  {
    id: "juniper",
    name: "Juniper",
    title: "Forest Trail Explorer",
    description:
      "Silver ponytail, blue trail clothes, and a leafy teal field pack.",
    portraitClass: "explorer-portrait--juniper",
    modelPath: "/assets/kenney-mini-characters/juniper-female-c.glb",
    colors: {
      skin: 0x6f4632,
      hair: 0x2a1f1d,
      jacket: 0x287b70,
      trousers: 0x3d5263,
      pack: 0x286c63,
      packLight: 0x55aa91,
      scarf: 0xf2b84b,
    },
  },
  {
    id: "rowan",
    name: "Rowan",
    title: "Sunset Trail Explorer",
    description:
      "Short dark hair, green trail clothes, and a coral field pack.",
    portraitClass: "explorer-portrait--rowan",
    modelPath: "/assets/kenney-mini-characters/rowan-male-f.glb",
    colors: {
      skin: 0xb17752,
      hair: 0x7c3627,
      jacket: 0x4e83a5,
      trousers: 0x435478,
      pack: 0xb95351,
      packLight: 0xe9856d,
      scarf: 0x5b8fbe,
    },
  },
] as const;

export function isExplorerId(value: unknown): value is ExplorerId {
  return EXPLORER_IDS.includes(value as ExplorerId);
}

export function explorerById(id: ExplorerId): ExplorerDefinition {
  return explorers.find((explorer) => explorer.id === id) ?? explorers[0]!;
}
